module.exports = __webpack_public_path__ + "assets/e3fa1eb5f7f8850bd4f04adf2fd5a23d.png";